
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import Editor from "@common/src/components/scope/editor/index.vue";
import { Table } from "@common/src/utils/decorator";
import { getImageSize, emptyToLine } from "@common/src/utils/common";
import CouponDiscountContent from "../components/coupon-discount-content.vue";
import CampaignTempItem from "./components/campaign-temp-item.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import appCode from "@common/src/utils/app-code";
import { InjectFunction } from "@common/src/utils/decorator";
import SwitchAutoTips from "../components/switch-auto-tips.vue";
import ImgLoader from "@common/src/components/scope/img-loader/index.vue";

const app = namespace("app");
const store = namespace("store");
const campaign = namespace("campaign");
const coupon = namespace("coupon");
const base = namespace("base");
const defaultBg = "rgb(236,246,245)";
const defaultBannerUrl = "https://static.gtech.asia/static/speedbiz/minipro/accumulate-banner.jpg";
const defaultCampaignThumbnail = "https://static.gtech.asia/static/speedbiz/minipro/accumulate-small.jpg";
@InjectFunction("dayjs", "permitApp")
@Component({
  components: { FileUpload, Editor, CouponDiscountContent, CampaignTempItem, SwitchAutoTips, ImgLoader }
})
@Table("loadListData", { pageSize: 5 })
export default class CollectCustomerEdit extends Vue {
  @store.State storeData;
  @campaign.Action createSaveCampaign;
  @campaign.Action queryCampaignDetail;
  @campaign.Action queryOpCollectCustomerList;
  @app.State autoPopOpTemplate;
  @base.Action getDictionaryList;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @coupon.Action queryList;
  @app.Mutation setPBPX;
  emptyToLine = emptyToLine;
  campaignForm: any = {
    id: "defalut", // 上传图片用的
    campaignName: "",
    campaignBeginTime: "",
    campaignEndTime: "",
    campaignImage: defaultBannerUrl,
    campaignThumbnail: defaultCampaignThumbnail, // 活动缩略图
    campaignDesc: "",
    isCoupon: "0",
    campaignContext: "",
    campaignImageColor: "",
    prize: {
      bindCode: ""
    },
    storeTypeList: [],
    // 非业务直接参数
    time: null,
    bannerType: "default" // default customize
  };
  showCouponSelector: boolean = false;
  campaignFormRules: any = {
    campaignName: [
      { required: true, message: t("v210801.please-enter-the-campaign-title"), trigger: "blur" },
      { max: 14, message: t("v210801.the-maximum-length"), trigger: "blur" }
    ],
    storeTypeList: {
      type: "array",
      require: true,
      message: t("v270.please-select-a-synchronized-store"),
      trigger: "change"
    },
    time: { type: "array", required: true, message: t("v210801.please-select-an"), trigger: "change" },
    campaignImage: { required: true, validator: this.checkFrontImage }
  };
  storeTypeListAll: any = [];
  storeTypeListShow: any = [];
  checkFrontImage(rule, value, callback) {
    if (this.campaignForm.bannerType === "default") {
      callback();
    } else {
      if (!value) {
        callback(new Error(t("v210831.please-upload-the-cover-img")));
      } else {
        callback();
      }
    }
  }
  handleBannerChange(val) {
    if (val === "default") {
      this.campaignForm.campaignImageColor = defaultBg;
      this.campaignForm.campaignImage = defaultBannerUrl;
      this.defaultBannerList = [];
    } else {
      this.$nextTick(() => {
        this.campaignForm.campaignImage = "";
      });
    }
  }
  get breadData() {
    return [
      { name: t("v210801.customer-accumulation-activities"), path: "/marketing/campaign/collect-customer" },
      {
        name: this.isAdd ? t("v210801.new-customer-accumulation") : t("v210901.edit-customer-accumulation-activities")
      }
    ];
  }
  searchForm = {
    activityName: "",
    activityStatus: undefined
  };
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  selectedRow: any = {};
  confirmSelecteRow: any = {};
  handleRowSelect(rows) {
    this.selectedRow = rows.length > 0 ? rows[0] : {};
  }
  checkable(row) {
    return !Object.keys(this.selectedRow).length || this.selectedRow.activityCode === row.activityCode;
  }
  handleSelectedCoupon() {
    if (!this.selectedRow) {
      return this.$message.error(t("v210801.please-select-a"));
    }
    this.confirmSelecteRow = Object.assign({}, this.selectedRow);
    this.storeTypeListShow = this.storeTypeListAll.slice().filter(storeType => {
      return this.confirmSelecteRow.storeTypeList.includes(storeType.value);
    });
    this.campaignForm.storeTypeList = this.confirmSelecteRow.storeTypeList;
    this.showCouponSelector = false;
  }
  get couponSearchList() {
    return [
      {
        label: t("v210801.coupon-name"),
        type: "input",
        value: "",
        prop: "activityName"
      },
      {
        label: t("v210801.state"),
        type: "select",
        selectList: this.campaignStatusList,
        value: undefined,
        prop: "activityStatus"
      }
    ];
  }
  campaignStatusList: any = [];
  get isAdd() {
    return this.$route.name === "collectCustomerAdd";
  }
  created() {
    this.setPBPX(52);
    this.init();
  }
  get id() {
    return this.$route.params.id;
  }
  get copyCode() {
    return this.$route.query.copyCode;
  }
  defaultBannerList: any = [];
  async init() {
    if (appCode === "speedbiz-operation") {
      await this.getDictionaryList("store_type").then(data => {
        this.storeTypeListAll = data;
        this.storeTypeListShow = data;
      });
    } else {
      this.queryOpCollectCustomerList().then(data => {
        this.opCollectCustomerList = data.data;
        if (this.autoPopOpTemplate && this.opCollectCustomerList.length > 0 && this.isAdd && !this.copyCode) {
          this.showSelectOpTemplate = true;
        }
      });
    }
    this.handleBannerChange("default");
    this.getDictionaryList("coupon_activity_status").then(data => {
      this.campaignStatusList = data.filter(item => item.value !== "05" && item.value !== "07");
    });
    if (!this.isAdd || this.copyCode) {
      this.queryCampaignDetail({ campaignCode: this.id || this.copyCode }).then(data => {
        this.campaignInfoSet(data.data);
      });
    }
  }
  campaignInfoSet(campaignInfo, type?) {
    campaignInfo.time = [
      dayjs(campaignInfo.campaignBeginTime).format("YYYYMMDDHHmmss"),
      dayjs(campaignInfo.campaignEndTime).format("YYYYMMDDHHmmss")
    ];
    // 复制和引用op活动删除code
    if (this.copyCode || type === "quote") {
      delete campaignInfo.campaignCode;
    }
    if (campaignInfo.campaignImage === defaultBannerUrl) {
      campaignInfo.bannerType = "default";
    } else {
      campaignInfo.bannerType = "customize";
      this.defaultBannerList = [{ url: campaignInfo.campaignImage }];
    }
    if (appCode === "speedbiz-operation") {
      if (campaignInfo.prize) {
        // 如果有券，限制门店范围
        this.storeTypeListShow = this.storeTypeListAll.slice().filter(storeType => {
          return campaignInfo.prize.bindObj.storeTypeList.includes(storeType.value);
        });
      }
    }
    this.confirmSelecteRow = campaignInfo.prize ? campaignInfo.prize.bindObj : {};
    this.campaignForm = Object.assign({}, campaignInfo);
  }
  handleRemoveCoupon() {
    this.selectedRow = {};
    this.confirmSelecteRow = {};
  }
  handleBannerUploadSuccess(url) {
    (this.$refs.campaignForm as any).validateField("campaignImage");
    this.getImageColor(url);
  }
  handleShowCoupon() {
    this.showCouponSelector = true;
    this.loadListData();
  }
  getImageColor(url) {
    console.log(url);
    const _this = this;
    let canvas = document.createElement("canvas"),
      ctxt = canvas.getContext && canvas.getContext("2d");
    const img = new Image();
    // 要求跨域处理
    img.crossOrigin = "Anonymous";
    img.src = url; //src也可以是从文件选择控件中取得。
    img.onload = () => {
      let [width, height] = getImageSize(img);
      canvas.height = height;
      canvas.width = width;
      ctxt.drawImage(img, 0, 0);
      const data = ctxt.getImageData(~~(width / 2), height - 2, 1, 1).data; //读取整张图片的像素。
      let [r, g, b] = data;
      console.log(33333, r, g, b);
      _this.campaignForm.campaignImageColor = `rgb(${[r, g, b].join()})`;
    };
  }
  couponList: any = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryList({
      ...this.searchForm,
      activityStatus: this.searchForm.activityStatus ? this.searchForm.activityStatus : "01,04",
      activeStatus: "1",
      // pageNum: this.mix_pageNum,
      pageNum: 1,
      // pageSize: this.mix_pageSize
      pageSize: 999
    }).then(data => {
      this.couponList = data.data.list;
      return data;
    });
  }
  saveCampaign() {
    (this.$refs.campaignForm as any).validate(valid => {
      console.log(valid);
      if (valid) {
        this.campaignForm.campaignBeginTime = this.campaignForm.time[0];
        this.campaignForm.campaignEndTime = this.campaignForm.time[1];
        if (this.campaignForm.isCoupon === "1") {
          if (!this.confirmSelecteRow.activityCode) {
            return this.$message.error(t("v210906.please-select-a-coupon"));
          } else {
            this.campaignForm.prize = {
              bindCode: this.confirmSelecteRow.activityCode
            };
          }
        }
        if (dayjs(this.campaignForm.time[1]).toDate().getTime() < Date.now()) {
          return this.$message.error(t("v210801.end-time-cannot"));
        }
        this.btnStartLoading();
        this.createSaveCampaign(this.campaignForm)
          .then(() => {
            this.isAdd
              ? this.$message.success(t("v210801.activity-created-successfully"))
              : this.$message.success(t("v210801.activity-edited-successfully"));
            this.$router.push("/marketing/campaign/collect-customer");
          })
          .finally(() => {
            this.btnStopLoading();
          });
      }
    });
  }
  showSelectOpTemplate: boolean = false; // 选择op活动模板弹窗
  opCollectCustomerList: any = [];
  handleSelectTemplate() {
    this.showSelectOpTemplate = true;
  }
  handleConfirmTemplate() {
    this.showSelectOpTemplate = false;
    this.campaignInfoSet(this.selectedTemp, "quote");
  }
  selectedTemp: any = {};
  handleTempClick(campaign) {
    this.selectedTemp = campaign;
  }
  handleIsCouponChange() {
    this.storeTypeListShow = this.storeTypeListAll.slice();
    this.confirmSelecteRow = {};
    this.campaignForm.storeTypeList = [];
  }
}
